import React from "react";
import { Typography } from "@mui/material";
import { StyledBlogImageContent, blogImageContentClasses } from "./StyledBlogImageContent";

interface BlogImageContentProps {
  value: any;
  alt?: string;
  copyright?: string;
  heading?: string;
}

export const BlogImageContent = ({ value, alt, copyright, heading }: BlogImageContentProps) => {
  return (
    <StyledBlogImageContent className={blogImageContentClasses.root}>
      {heading && (
        <Typography className={blogImageContentClasses.heading}>
          {heading}
        </Typography>
      )}
      <img
        src={value}
        alt={alt || ""}
        className={blogImageContentClasses.image}
      />
      {copyright && (
        <p className={blogImageContentClasses.copyright}>{copyright}</p>
      )}
    </StyledBlogImageContent>
  );
};

